import AuthenticatedController from './AuthenticatedController';
import { buildQueryString } from '@mm/utils';
import * as APIRoutes from '@mm/api-routes';
import AdSetModel, { AdSetWithRelationsModel } from '../model/AdSetModel';

type AdSetsResponse = {
  adSets: AdSetModel[];
  pagination: {
    isLastPage: boolean;
    page: number;
    perPage: number;
    total: number;
    totalPages: number;
  };
};

type FullAdSetsResponse = {
  data: AdSetWithRelationsModel[];
  next: string | null;
  error?: string;
};

type AvailableAdSetsOptions = {
  botId?: number;
  accountId?: string;
  next?: string;
  limit?: number;
};

export default class AdSetController extends AuthenticatedController {
  static async allNonDeprecated(
    options: AvailableAdSetsOptions,
  ): Promise<FullAdSetsResponse> {
    const { accountId, next, limit, botId } = options;
    const queryString = buildQueryString({
      ad_account_id: accountId,
      bot_id: botId,
      next,
      limit,
    });

    const url = APIRoutes.FULL_AD_SETS(queryString);
    return super.get(url);
  }

  static async retrieveAll(
    fbPageId: number,
    adAccountId: string,
    campaignId: number,
    remote: boolean = true,
  ): Promise<AdSetsResponse> {
    const queryString = buildQueryString({
      facebook_page_id: fbPageId,
      remote_campaign_id: campaignId,
      ad_account_id: adAccountId,
      remote,
    });

    const url = APIRoutes.AD_SETS(queryString);
    return super.get(url);
  }
}
